import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiRequest } from '../../../api';

export const fetchPayments = createAsyncThunk('payments/fetchPayments', async () => {
    return await apiRequest('/api/v1/payments');
});

const paymentsSlice = createSlice({
    name: 'payments',
    initialState: {
        items: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPayments.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPayments.fulfilled, (state, action) => {
                state.loading = false;
                state.items = action.payload;
            })
            .addCase(fetchPayments.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default paymentsSlice.reducer; 